"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
exports.NotificationType = {
    InvoiceApprovalNeeded: "INVOICE_APPROVAL_NEEDED",
    InvoiceApproved: "INVOICE_APPROVED",
    InvoiceRejected: "INVOICE_REJECTED",
    InvoiceScheduled: "INVOICE_SCHEDULED",
    InvoicePending: "INVOICE_PENDING",
    InvoicePaid: "INVOICE_PAID",
    InvoiceCanceled: "INVOICE_CANCELED",
    InvoiceCreated: "INVOICE_CREATED",
    InvoiceEmailed: "INVOICE_EMAILED",
    InvoiceFailed: "INVOICE_FAILED",
    CounterpartyOnboardingCompleted: "COUNTERPARTY_ONBOARDING_COMPLETED",
};
